var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavRewardTwoColor = function SvgNavRewardTwoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1,
    fillRule: "evenodd",
    d: "M34.5 29.016C46.224 26.832 48 17.064 48 6.6a1.8 1.8 0 00-1.8-1.8h-7.8V1.2A1.2 1.2 0 0037.2 0H10.8a1.2 1.2 0 00-1.2 1.2v3.6H1.8A1.8 1.8 0 000 6.6c0 10.464 1.776 20.232 13.5 22.416a14.402 14.402 0 006.9 4.104v7.68h-6a1.2 1.2 0 00-1.2 1.2v4.8a1.2 1.2 0 001.2 1.2h19.2a1.2 1.2 0 001.2-1.2V42a1.2 1.2 0 00-1.2-1.2h-6v-7.68a14.402 14.402 0 006.9-4.104zm3.445-10.173V8H44c-.182 7.952-1.72 13.47-7 16 .628-1.647.948-3.395.945-5.157zM10.035 8H4c.205 7.958 1.738 13.48 7 16a14.323 14.323 0 01-.966-5.148V8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.194 24.693v-1.388c-1.53-.276-2.894-1.071-3.643-2.305a1.303 1.303 0 01.444-1.788 1.312 1.312 0 011.797.44c.354.585 1.314 1.171 2.701 1.156 1.744 0 2.892-.955 2.892-1.74 0-.338-.15-.677-.622-1.013-.496-.353-1.299-.641-2.37-.73-1.33-.111-2.613-.506-3.605-1.194-1.005-.7-1.788-1.778-1.788-3.15 0-1.358.764-2.476 1.768-3.206.684-.496 1.52-.846 2.427-1.02v.016-1.47c0-.718.587-1.301 1.308-1.301.724 0 1.31.583 1.31 1.302v1.455c1.23.236 2.338.8 3.114 1.63a1.298 1.298 0 01-.065 1.84 1.31 1.31 0 01-1.848-.064c-.465-.495-1.365-.92-2.513-.92-1.735 0-2.884.956-2.884 1.74 0 .302.152.653.668 1.011.526.366 1.339.653 2.325.733 1.39.115 2.685.507 3.67 1.207 1.013.719 1.72 1.799 1.72 3.136 0 1.36-.761 2.477-1.765 3.205a6.083 6.083 0 01-2.425 1.021v1.399a1.308 1.308 0 01-2.616 0v-.002z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 50.535,
    x2: 16.072,
    y1: 14.912,
    y2: -17.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#EAF639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8E71C"
  })))));
};
export default SvgNavRewardTwoColor;